import { GetProgrammaticCampaignCreativesEngagementsRO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";
import { DisplayPerformanceFilters } from "screens/CampaignPacing/screens/DisplayPerformance/DisplayPerformance";

export const getCreativeWithHighestEngagement = async (
  id: string,
  filters: DisplayPerformanceFilters
): Promise<GetProgrammaticCampaignCreativesEngagementsRO> => {
  const { data } =
    await apiService.get<GetProgrammaticCampaignCreativesEngagementsRO>(
      Endpoints.ProgrammaticCampaigns.CreativeEngagement.Get.CreativeWithHighestEngagement(
        id
      ),
      {
        params: {
          yearFrom: filters.yearFrom,
          yearTo: filters.yearTo,
          weekFrom: filters.weekFrom,
          weekTo: filters.weekTo,
        },
      }
    );
  return data;
};
